import { Alert, Tag } from 'antd';
import { debounce } from 'lodash-es';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { searchVendorSentProjectItems } from '../../api/finance/purchase-bill.js';
import styles from './purchase-bill-project-item-select.module.scss';

function PurcahseBillProjectItemSelect({ filters = {}, value, onChange, ...otherProps }) {
    const debounceTimeout = 200
    // Starts true so the "no items found" warning doesn't flash during the debounce.
    const [fetching, setFetching] = useState(true);
    const [options, setOptions] = useState([]);
    const fetchRef = useRef(0);

    useEffect(() => {
        debounceFetcher()
    }, [])

    const debounceFetcher = useMemo(() => {
        const loadOptions = () => {
            fetchRef.current += 1;
            const fetchId = fetchRef.current;
            setOptions([]);
            setFetching(true);
            searchVendorSentProjectItems('', filters).then(data => {
                const _items = data.map(({ id, name, project_id }) => ({
                    value: id,
                    label: `#${id} - ${name}`,
                    project_id
                }))
                if (fetchId !== fetchRef.current) {
                    // for fetch callback order
                    return;
                }
                setOptions(_items)
                setFetching(false);
                // Auto-select when there's only one item and nothing chosen yet.
                // With 2+ options leave it manual rather than guess.
                if (_items.length === 1 && !value?.length) {
                    onChange([_items[0].value], [_items[0]]);
                }
            })
        };
        return debounce(loadOptions, debounceTimeout);
    }, [filters, value, searchVendorSentProjectItems, debounceTimeout]);

    const handleChange = (val, checked) => {
        const selectedValues = checked
            ? [...value, val]
            : value?.filter((t) => t !== val);
        const selectedItems = options.filter(({ value }) => selectedValues.includes(value))
        onChange(selectedValues, selectedItems)
    }

    if (otherProps.disabled) {
        return
    }

    if (fetching) {
        return <div className={styles.loader}>Loading...</div>
    }

    if (!options.length) {
        return <Alert message="No items found for this vendor under this project — please verify the vendor and project match." type="warning" showIcon />
    }

    return (
        <div>{options.map(option => (
            <Tag.CheckableTag key={option.value} checked={value.indexOf(option.value) > -1} onChange={checked => handleChange(option.value, checked)}>
                {option.label}
            </Tag.CheckableTag>
        ))}</div>
    )
}

PurcahseBillProjectItemSelect.propTypes = {
    filters: PropTypes.object,
    value: PropTypes.arrayOf(PropTypes.number),
    onChange: PropTypes.func.isRequired,
    currentSelection: PropTypes.object
    // currentSelection: PropTypes.shape({
    //     id: PropTypes.number.isRequired,
    //     company: PropTypes.string.isRequired
    // })
}

export default PurcahseBillProjectItemSelect;